/**
 * Tarih/Saat yardımcı fonksiyonları
 * Tüm tarihler Türkiye saatinde (Europe/Istanbul, UTC+3) gösterilir
 */

// Türkiye saatine çevir
export const toTurkeyTime = (dateString, options = {}) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    
    const defaultOptions = {
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      ...options
    };
    
    return date.toLocaleString('tr-TR', defaultOptions);
  } catch {
    return dateString;
  }
};

// Sadece tarih (gün/ay/yıl)
export const toTurkeyDate = (dateString) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('tr-TR', { timeZone: 'Europe/Istanbul' });
  } catch {
    return dateString;
  }
};

// Sadece saat (saat:dakika:saniye)
export const toTurkeyTimeOnly = (dateString) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleTimeString('tr-TR', { timeZone: 'Europe/Istanbul' });
  } catch {
    return dateString;
  }
};

// Kısa format (06.04.2026 15:30)
export const toTurkeyShort = (dateString) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleString('tr-TR', { 
      timeZone: 'Europe/Istanbul',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return dateString;
  }
};

// Relative time (5 dakika önce, 2 saat önce)
export const toRelativeTime = (dateString) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    
    const now = new Date();
    const diff = now - date;
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    
    if (seconds < 60) return 'Az önce';
    if (minutes < 60) return `${minutes} dakika önce`;
    if (hours < 24) return `${hours} saat önce`;
    if (days < 7) return `${days} gün önce`;
    
    return toTurkeyShort(dateString);
  } catch {
    return dateString;
  }
};
